import { useEffect } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import WhatsAppFloat from "@/pages/home/components/WhatsAppFloat";
import CuartosFriosHero from "./components/CuartosFriosHero";
import CuartosFriosIntro from "./components/CuartosFriosIntro";
import CuartosFriosTypes from "./components/CuartosFriosTypes";
import CuartosFriosServices from "./components/CuartosFriosServices";
import CuartosFriosSectors from "./components/CuartosFriosSectors";
import CuartosFriosBenefits from "./components/CuartosFriosBenefits";
import CuartosFriosProcess from "./components/CuartosFriosProcess";
import CuartosFriosCta from "./components/CuartosFriosCta";

export default function CuartosFrios() {
  useScrollReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <Navbar />
      <main>
        <CuartosFriosHero />
        <CuartosFriosIntro />
        <CuartosFriosTypes />
        <CuartosFriosServices />
        <CuartosFriosSectors />
        <CuartosFriosBenefits />
        <CuartosFriosProcess />
        <CuartosFriosCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}